



































































import Vue from "vue";
import moment from "moment";
import { mapGetters } from "vuex";
import { MODULE_COLORS } from "@/utility/Constants";
import VFaIcon from "@/components/VFaIcon.vue";

export default Vue.extend({
    components: { VFaIcon },
    data() {
        return { moment, MODULE_COLORS };
    },
    props: ["analysisLogsProgress", "loading", "error", "licenseError", "notSupportedError"],
    computed: {
        ...mapGetters(["userDateFormat"]),
    },
});
